import Raf from 'raf-engine'

const loop = new Raf()

export default loop
